import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
const forWho = ['Mujeres de 40 a 60 años que han notado un aumento de peso abdominal repentino.', 'Latinas en USA que trabajan a tiempo completo y tienen poco tiempo para cocinar platos complejos.', 'Mujeres que sufren de sofocos, neblina mental o insomnio.', 'Aquellas que quieren soluciones basadas en ciencia, no en modas pasajeras de redes sociales.'];
const notForWho = ["Personas que buscan una 'pastilla milagrosa' para bajar de peso en 3 días.", 'Atletas de alto rendimiento que ya tienen un metabolismo optimizado.', 'Quienes no están dispuestas a ajustar sus horarios de comida por 21 días.'];
export function WhoIsItFor() {
  return <section className="py-20 px-6 md:px-12 bg-cream/50" data-id="element-182">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-183">
        <motion.div initial={{
        opacity: 0,
        x: -20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 rounded-3xl shadow-sm border-t-8 border-sage" data-id="element-184">
          <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-185">
            <span className="bg-sage/20 text-sage p-2 rounded-full" data-id="element-186">
              <Check size={24} data-id="element-187" />
            </span>
            Esto SÍ es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-188">
            {forWho.map((text, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-189">
                <Check className="text-sage shrink-0 mt-1" size={20} data-id="element-190" />
                <span data-id="element-191">{text}</span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 20
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-white p-8 rounded-3xl shadow-sm border-t-8 border-coral" data-id="element-192">
          <h3 className="text-2xl font-bold text-charcoal mb-6 flex items-center gap-3" data-id="element-193">
            <span className="bg-coral/20 text-coral p-2 rounded-full" data-id="element-194">
              <X size={24} data-id="element-195" />
            </span>
            Esto NO es para ti si...
          </h3>
          <ul className="space-y-4" data-id="element-196">
            {notForWho.map((text, i) => <li key={i} className="flex items-start gap-3 text-gray-700" data-id="element-197">
                <X className="text-coral shrink-0 mt-1" size={20} data-id="element-198" />
                <span data-id="element-199">{text}</span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}